const chaseTimeLineData = [
  {
    type: "NB",
    items: [
      {
        day: 1,
        emailContent: {
          title: "Document Information Chase Begins",
          heading:
            "Urgent Request: Submit Additional Information Avoid Policy Cancellation!",
        },
        smsContent: {
          data: `Urgent: Your insurer has requested additional information for policy . Supply it now to avoid cancellation: `,
        },
      },
      {
        day: 3,
        emailContent: {
          title: "Reminder with Increased Urgency",
          heading:
            "Action Required: Documentation Needed Keep Your Policy Valid!",
        },
        smsContent: {
          data: `Reminder: Your insurer requires documentation for your policy . Please submit to ensure policy validity: `,
        },
      },
      {
        day: 5,
        emailContent: {
          title: "Last Few Hours Hour Reminder",
          heading:
            "48 Hours Left to Provide Documents, Before Cancellation Notice",
        },
        smsContent: {
          data: `Alert: You have 48 hours left to provide documents for policy  as requested by your insurer: `,
        },
      },
      {
        day: 7,
        emailContent: {
          title: "Last Day Before Cancellation Process",
          heading:
            "Last Day to Submit Documents Before Cancellation Notice Act Now!",
        },
        smsContent: {
          data: `Last Call: Today is the final day to submit required documents for policy  to your insurer: `,
        },
      },
      {
        day: 9,
        emailContent: {
          title: "Notice of Cancellation Issued - 6 Days Left",
          heading:
            "Cancellation Alert: 6 Days Left to Submit Documents Urgent!",
        },
        smsContent: {
          data: `Notice of Cancellation Issued for policy  . You have 6 days left to submit required documents: `,
        },
      },
      {
        day: 11,
        emailContent: {
          title: "Notice of Cancellation Issued - 4 Days Left",
          heading: "Important: Documents Needed to Avoid Policy Cancellation",
        },
        smsContent: {
          data: `Urgent: Please submit documents for policy  to avoid cancellation. Please respond: `,
        },
      },
      {
        day: 13,
        emailContent: {
          title: "Notice of Cancellation - 1 Day Left",
          heading: "Urgent Reminder: Second Last Day to Submit Documents",
        },
        smsContent: {
          data: `Second last day to submit documents for policy  to avoid cancellation. Please respond: `,
        },
      },
      {
        day: 14,
        emailContent: {
          title: "Notice of Cancellation - Final Day",
          heading: "Today's Deadline: Last Chance to Submit Documents",
        },
        smsContent: {
          data: `Deadline Today: Final chance to submit documents for policy  to your insurer: `,
        },
      },
    ],
  },

  // ---------------------------------- [  NCB MISMATCH CHASE ] ------------------------

  {
    type: "NCB",
    items: [
      {
        day: 1,
        emailContent: {
          title: "Document Information Chase Begins",
          heading:
            "Reminder: Submit No Claim Bonus Proof to Avoid Potential Premium Hike",
        },
        smsContent: {
          data: `Reminder: Your insurer needs No Claims Bonus proof for . Submit now to avoid premium hike: `,
        },
      },
      {
        day: 3,
        emailContent: {
          title: "Reminder",
          heading:
            "Provide No Claim Bonus Proof to Prevent Potential Premium Increase",
        },
        smsContent: {
          data: `Submit NCB proof for policy  to avoid NCB reset to 0, which may increase premium. Respond ASAP : `,
        },
      },
      {
        day: 5,
        emailContent: {
          title: "Reminder",
          heading: "2 Days Left: Submit No Claim Bonus Proof Urgently",
        },
        smsContent: {
          data: `2 Days Left: Urgently submit NCB proof for . Your NCB will be changed to 0: `,
        },
      },
      {
        day: 7,
        emailContent: {
          title: "Final Reminder Before Mismatch Process Begins",
          heading: "Last Chance: Submit No Claim Bonus Proof Today",
        },
        smsContent: {
          data: ` Last Chance: Submit NCB proof for  today to prevent NCB reset and potential premium increase: `,
        },
      },
    ],
  },
  // ---------------------------------- [  NCB MISMATCH CHASE ] ------------------------

  // ---------------------------------- [  MNCB MISMATCH CHASE ] ------------------------
  {
    type: "MNCB",
    items: [
      {
        day: 1,
        emailContent: {
          title: "Document Information Chase Begins",
          heading:
            "Reminder: Submit Mirrored No Claims Bonus Proof to Avoid Premium Hike",
        },
        smsContent: {
          data: `Reminder: Your insurer needs Mirrored No Claims Bonus proof for . Submit now to avoid premium hike: `,
        },
      },
      {
        day: 3,
        emailContent: {
          title: "Reminder",
          heading:
            "Provide Mirrored No Claims Bonus Proof to Prevent Premium Increase",
        },
        smsContent: {
          data: `Submit MNCB proof for policy  to avoid MNCB reset to 0, which may increase premium. Respond ASAP : `,
        },
      },
      {
        day: 5,
        emailContent: {
          title: "Reminder",
          heading:
            "2 Days Left: Urgently Submit Mirrored No Claims Bonus Proof",
        },
        smsContent: {
          data: `2 Days Left: Urgently submit MNCB proof for . Your MNCB will be changed to 0: `,
        },
      },
      {
        day: 7,
        emailContent: {
          title: "Final Reminder Before Mismatch Process Begins",
          heading: "Last Chance: Submit Mirrored No Claims Bonus Proof Today",
        },
        smsContent: {
          data: ` Last Chance: Submit MNCB proof for  today to prevent MNCB reset and potential premium increase: `,
        },
      },
    ],
  },
  // ---------------------------------- [  MNCB MISMATCH CHASE ] ------------------------

  // ---------------------------------- [  CUE MISMATCH CHASE ] ------------------------
  {
    type: "CUE",
    items: [
      {
        day: 1,
        emailContent: {
          title: "Document Information Chase Begins",
          heading:
            "Reminder: Submit Proof of All Previous Claims to Avoid Premium Hike",
        },
        smsContent: {
          data: `Reminder: Your new insurer needs proof of all previous claims  to avoid premium hike: `,
        },
      },
      {
        day: 3,
        emailContent: {
          title: "Reminder",
          heading:
            "Provide Proof of All Claims to Avoid Issues with Undisclosed Claims",
        },
        smsContent: {
          data: `Submit proof of all claims for policy  to avoid undisclosed claims being added. Respond ASAP: `,
        },
      },
      {
        day: 5,
        emailContent: {
          title: "Reminder",
          heading: "2 Days Left: Urgently Submit Proof of All Previous Claims",
        },
        smsContent: {
          data: ` 2 Days Left: Urgently submit proof of all previous claims for policy :  : `,
        },
      },
      {
        day: 7,
        emailContent: {
          title: "Final Reminder Before Mismatch Process Begins",
          heading: "Last Chance: Submit Proof of Previous Claims Today",
        },
        smsContent: {
          data: `Last Chance: Submit proof of previous claims for :  today to undisclosed claims being added: `,
        },
      },
    ],
  },
  // ---------------------------------- [  CUE MISMATCH CHASE ] ------------------------

  // ---------------------------------- [  CNCB MISMATCH CHASE ] ------------------------
  {
    type: "CNCB",
    items: [
      {
        day: 1,
        emailContent: {
          title: "Document Information Chase Begins",
          heading: "Urgent: Please Submit No Claims Bonus Proof",
        },
        smsContent: {
          data: `Reminder: Your insurer needs No Claims Bonus proof for  Submit now to avoid premium hike: `,
        },
      },
      {
        day: 3,
        emailContent: {
          title: "Reminder",
          heading:
            "Provide No Claims Bonus Proof to Prevent Potential Cancellation",
        },
        smsContent: {
          data: `Submit NCB proof for policy  to avoid NCB reset to 0, which may increase premium. Respond ASAP: `,
        },
      },
      {
        day: 5,
        emailContent: {
          title: "Reminder",
          heading: "2 Days Left: Urgently Submit No Claims Bonus Proof",
        },
        smsContent: {
          data: ` 2 Days Left: Urgently submit NCB proof for . Your NCB will
            be changed to 0: `,
        },
      },
      {
        day: 7,
        emailContent: {
          title: "Final Reminder Before Mismatch Process Begins",
          heading:
            "Submit No Claims Bonus Proof Today to Avoid Cancellation Notice",
        },
        smsContent: {
          data: ` Last Chance: Submit NCB proof for  today to prevent NCB
            reset and potential premium increase: `,
        },
      },
      {
        day: 9,
        emailContent: {
          title: "Cancellation Notice Warning",
          heading:
            "NCB Proof Missing, Policy Cancellation in 6 Days Unless Action Taken",
        },
        smsContent: {
          data: ` As NCB proof for not provided, policy will be cancelled in 6 days, unless
            payment made or proof provided: `,
        },
      },
      {
        day: 11,
        emailContent: {
          title: "Cancellation Notice Warning",
          heading:
            "NCB Proof Still Needed, Policy at Risk of Cancellation in 4 Days",
        },
        smsContent: {
          data: `Reminder: NCB proof for not submitted. Policy due for cancellation in 4
            days, unless payment made or proof provided: `,
        },
      },
      {
        day: 13,
        emailContent: {
          title: "Cancellation Notice Warning",
          heading:
            "No Claims Bonus Proof Required, Policy Facing Cancellation in 2 Days",
        },
        smsContent: {
          data: ` Urgent: NCB proof for not submitted. Policy due for cancellation in 2 days,
            unless payment made or proof provided: `,
        },
      },
      {
        day: 14,
        emailContent: {
          title: "Cancellation Notice Warning",
          heading:
            "Final Reminder: Provide NCB Proof or Face Policy Cancellation at Midnight",
        },
        smsContent: {
          data: `Final Reminder: NCB proof for not provided. Policy due for cancellation
            today, unless payment made or proof provided: `,
        },
      },
    ],
  },
  // ---------------------------------- [  CNCB MISMATCH CHASE ] ------------------------

  // ---------------------------------- [  CASH MNCB MISMATCH CHASE ] ------------------------
  {
    type: "CMNCB",
    items: [
      {
        day: 1,
        emailContent: {
          title: "Document Information Chase Begins",
          heading: "Urgent: Submit Mirrored No Claims Bonus Proof Today",
        },
        smsContent: {
          data: `Reminder: Your insurer needs Mirrored No Claims Bonus proof for  to avoid premium hike: `,
        },
      },
      {
        day: 3,
        emailContent: {
          title: "Reminder",
          heading: "Reminder: Provide Mirrored No Claims Bonus Proof ASAP",
        },
        smsContent: {
          data: `Submit MNCB proof for policy   to avoid NCB reset to 0,
            which may increase premium. Respond ASAP: `,
        },
      },
      {
        day: 5,
        emailContent: {
          title: "Reminder",
          heading:
            "2 Days Left: Urgently Submit Mirrored No Claims Bonus Proof",
        },
        smsContent: {
          data: `2 Days Left: Urgently submit MNCB proof for . Your MNCB
            will be changed to 0: `,
        },
      },
      {
        day: 7,
        emailContent: {
          title: "Final Reminder Before Mismatch Process Begins",
          heading:
            "Submit Mirrored NCB Proof Today to Avoid Cancellation Notice",
        },
        smsContent: {
          data: `Last Chance: Submit MNCB proof for  today to prevent
            MNCB reset and potential premium increase: `,
        },
      },
      {
        day: 9,
        emailContent: {
          title: "Cancellation Notice Warning",
          heading: "Mirrored NCB Proof Missing, Policy Cancellation in 6 Days",
        },
        smsContent: {
          data: `As MNCB proof for not provided, policy will be cancelled in 6 days, unless
            payment made or proof provided: `,
        },
      },
      {
        day: 11,
        emailContent: {
          title: "Cancellation Notice Warning",
          heading:
            "Mirrored NCB Proof Still Needed, Policy Cancellation in 4 Days",
        },
        smsContent: {
          data: `Reminder: MNCB proof for not submitted. Policy due for cancellation in 4
            days, unless payment made or proof provided: `,
        },
      },
      {
        day: 13,
        emailContent: {
          title: "Cancellation Notice Warning",
          heading: "Urgent: MNCB Proof Required, Policy Cancellation in 2 Days",
        },
        smsContent: {
          data: `Urgent: MNCB proof for not submitted. Policy due for cancellation in 2
            days, unless payment made or proof provided: `,
        },
      },
      {
        day: 14,
        emailContent: {
          title: "Cancellation Notice Warning",
          heading:
            "Final Reminder: Provide MNCB Proof, Policy Cancellation Today",
        },
        smsContent: {
          data: `Final Reminder: MNCB proof for not provided. Policy due for cancellation
            today, unless payment made or proof provided: `,
        },
      },
    ],
  },
  // ---------------------------------- [  CASH MNCB MISMATCH CHASE ] ------------------------

  // ---------------------------------- [  CASH CUE MISMATCH CHASE ] ------------------------
  {
    type: "CCUE",
    items: [
      {
        day: 1,
        emailContent: {
          title: "Document Information Chase Begins",
          heading: "We Have Found Undisclosed Claims, Proof Required",
        },
        smsContent: {
          data: `Reminder: Your new insurer needs proof of all previous claims  to avoid premium hike: `,
        },
      },
      {
        day: 3,
        emailContent: {
          title: "Reminder",
          heading: "Your Insurer Requires Proof of Your Claims History",
        },
        smsContent: {
          data: `Submit proof of all claims for policy  to avoid undisclosed
            claims being added. Respond ASAP: `,
        },
      },
      {
        day: 5,
        emailContent: {
          title: "Reminder",
          heading: "2 Days Left: Urgently Submit Proof of Previous Claims",
        },
        smsContent: {
          data: `2 Days Left: Urgently submit proof of all previous claims for policy  : `,
        },
      },
      {
        day: 7,
        emailContent: {
          title: "Final Reminder Before Mismatch Process Begins",
          heading: "Last Chance to Submit Proof of Previous Claims Today",
        },
        smsContent: {
          data: `Last Chance: Submit proof of previous claims for:  today to
            prevent undisclosed claims being added: `,
        },
      },
      {
        day: 9,
        emailContent: {
          title: "Cancellation Notice Warning",
          heading: "Policy Cancellation in 6 Days Unless Proof Provided",
        },
        smsContent: {
          data: `As proof of previous claims not provided, policy will be cancelled in 6 days,
            unless payment made or proof provided: `,
        },
      },
      {
        day: 11,
        emailContent: {
          title: "Cancellation Notice Warning",
          heading: "Reminder: Policy Cancellation in 4 Days, Act Now",
        },
        smsContent: {
          data: `Reminder: Proof of past claims not submitted. Policy due for cancellation in
            4 days, act now: `,
        },
      },
      {
        day: 13,
        emailContent: {
          title: "Cancellation Notice Warning",
          heading: "Urgent: Policy Due for Cancellation in 4 Days, Act Now",
        },
        smsContent: {
          data: `Urgent: Proof of past claims not submitted. Policy due for cancellation in 4
            days, act now: `,
        },
      },
      {
        day: 14,
        emailContent: {
          title: "Cancellation Notice Warning",
          heading:
            "Final Reminder: Policy Due for Cancellation in 4 Days, Act Now",
        },
        smsContent: {
          data: `Final Reminder: Proof of past claims not submitted. Policy due for
            cancellation in 4 days, act now: `,
        },
      },
    ],
  },
  // ---------------------------------- [  CASH CUE MISMATCH CHASE ] ------------------------

  // ---------------------------------- [  Renewals - Rebroke Chase ] ------------------------
  {
    type: "RRB",
    items: [
      {
        day: 1,
        emailContent: {
          title: "Document Information Chase Begins",
          heading: "Policy Renewal: Your Insurer Has Requested Information",
        },
        smsContent: {
          data: `Policy Renewal: Your insurer requires information for policy . Submit now to avoid insurer change: `,
        },
      },
      {
        day: 3,
        emailContent: {
          title: "Daily Reminder",
          heading: "Reminder: Submit Renewal Information to Prevent Increase",
        },
        smsContent: {
          data: `Reminder: Submit required renewal information for your policy, to prevent
            potential premium increase : `,
        },
      },
      {
        day: 5,
        emailContent: {
          title: "Reminder",
          heading:
            "Information Required following Renewal to Avoid Insurer Change",
        },
        smsContent: {
          data: `Your insure has requested information for policy  submit
            now to avoid your insurer changing: `,
        },
      },
      {
        day: 7,
        emailContent: {
          title: "Final Reminder Before Cancellation Notice",
          heading: "Not Long Left: Submit Requested Renewal Information",
        },
        smsContent: {
          data: `Not Long Left: Submit required renewal information for your policy, to
            prevent potential premium increase: `,
        },
      },
      {
        day: 9,
        emailContent: {
          title: "Notice of Cancellation Issued",
          heading:
            "Renewal Info Outstanding, Submit Now to Avoid Potential Increase",
        },
        smsContent: {
          data: `Renewal Alert: Your insure has requested more info, submit now to avoid
            your insurer changing: `,
        },
      },
      {
        day: 11,
        emailContent: {
          title: "Reminder",
          heading: "Not Long Left: Submit Requested Renewal Information",
        },
        smsContent: {
          data: `Your insure has requested information for policy  submit
            now to avoid your insurer changing: `,
        },
      },
      {
        day: 13,
        emailContent: {
          title: "Urgent 48-Hour Notice",
          heading: "Urgent: Submit Renewal Information Within 48 Hours",
        },
        smsContent: {
          data: `Urgent: Submit required renewal information for your policy, to prevent
            potential premium increase: `,
        },
      },
      {
        day: 14,
        emailContent: {
          title: "Final 24-Hour Alert",
          heading:
            "Last Call: Submit Requested Info or Your Insurer Will Change Tonight",
        },
        smsContent: {
          data: ` Last Call: Submit requested info for policy .  Your insurer will
            be changed in 24 hours: `,
        },
      },
    ],
  },
  // ---------------------------------- [  Renewals - Rebroke Chase ] ------------------------

  // ---------------------------------- [ Rebroke Chase ] ------------------------
  {
    type: "RB",
    items: [
      {
        day: 1,
        emailContent: {
          title: "Document Information Chase Begins",
          heading:
            "Validate Policy: Urgent Action Required to Avoid Insurer Change",
        },
        smsContent: {
          data: `Validate Policy: Urgent action required for . Avoid
            new insurer setup & possible premium increase. Submit details: `,
        },
      },
      {
        day: 3,
        emailContent: {
          title: "Reminder with Increased Urgency",
          heading:
            "Reminder: Urgent Policy Validation Needed to Prevent Changes",
        },
        smsContent: {
          data: ` Reminder: Your insurance policy , needs urgent
            validation. Prevent policy change & premium rise. Act now: `,
        },
      },
      {
        day: 5,
        emailContent: {
          title: "Reminder Before Potential Changes",
          heading: "Validate Your Policy Immediately to Avoid Premium Increase",
        },
        smsContent: {
          data: ` Last Reminder: Validate  immediately to maintain
            your policy and avoid potential premium increase. Submit now: `,
        },
      },
      {
        day: 7,
        emailContent: {
          title: "Urgent Reminder Before Countdown",
          heading:
            "Urgent: Submit Now to Avoid Insurer Change and Premium Increase",
        },
        smsContent: {
          data: `Urgent for . Submit now to avoid insurer change and
            potential premium increase. Act now: `,
        },
      },
      {
        day: 9,
        emailContent: {
          title: "Reminder",
          heading:
            "Few Days Left: Submit Info to Avoid New Insurer and Higher Premiums",
        },
        smsContent: {
          data: `Only a few days left!  : Submit required info to avoid
            being moved to a new insurer & risk higher premiums. Act now: `,
        },
      },
      {
        day: 11,
        emailContent: {
          title: "Reminder",
          heading:
            "Act Now: Submit to Avoid Insurer Change and Potential Premium Increase",
        },
        smsContent: {
          data: ` : Submit now to avoid insurer change and potential
            premium increase. Act now : `,
        },
      },
      {
        day: 13,
        emailContent: {
          title: "Count Down",
          heading:
            "2 Days Remaining: Urgent Submission Needed to Avoid Insurer Change",
        },
        smsContent: {
          data: `2 Days Remaining: Urgent for . Risk of new insurer &
            higher premium without your action. Details: `,
        },
      },
      {
        day: 14,
        emailContent: {
          title: "Final Day Notice",
          heading:
            "Deadline Today: Submit Info to Prevent Policy and Premium Changes",
        },
        smsContent: {
          data: `Today is the deadline: ! Submit info & prevent policy
            change and premium increase. Submit: `,
        },
      },
    ],
  },
  // ---------------------------------- [  Rebroke Chase ] ------------------------
];

export default chaseTimeLineData;
